import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import React, { useRef } from 'react';
import { Button, Content } from 'rsuite';
import { LoadingSpinerArea, LoadingSpinerLocal } from '../../../../../../components';
import { OPTIONS_DROPDOWN } from '../../data';
import { OptionsDropdown } from '../OptionsDropdown';
import styles from './ProductsByRangeChart.module.scss';

type ProductsByRangeChartProps = {
  className?: string;
  data?: Highcharts.SeriesOptionsType[];
  isLoading?: boolean;
};

const legends = {
  'Acima do máximo': 'Acima do preço máximo',
  'Acima do mínimo': 'Acima do preço mínimo',
  'Abaixo do mínimo': 'Abaixo do preço mínimo',
  'Acima do ideal': 'Acima do ideal',
  'Abaixo do ideal': 'Abaixo do ideal',
  'Igual ao preço ideal': 'Igual ao preço ideal',
  'Dentro do range': 'Dentro do range',
};

export const ProductsByRangeChart = ({ className, data, isLoading }: ProductsByRangeChartProps) => {
  const chartRef = useRef(null);

  const graficoData = {
    exporting: {
      enabled: false,
    },
    chart: {
      type: 'column',
    },
    title: {
      text: '',
    },
    legend: {
      labelFormatter: function (props) {
        return legends[this.name];
      },
    },
    xAxis: {
      type: 'datetime',
      startOfWeek: 0,
      labels: {
        allowOverlap: true,
        padding: 0,
        format: '{value: %d/%m/%Y}',
      },
      alignTicks: true,
    },
    yAxis: {
      min: 0,
      title: {
        text: '',
      },
      labels: {
        formatter: (props: any) => `${props.value}%`,
      },
    },
    tooltip: {
      pointFormat: '<span style="color:{series.color}">{series.name}</span>' + ': <b>{point.y}%</b> ({point.value:.0f})<br/>',
      shared: true,
      headerFormat: '<b>{point.key}</b><br/>',
      xDateFormat: '%d/%m/%Y',
    },
    plotOptions: {
      column: {
        stacking: 'percent',
        dataLabels: {
          enabled: true,
          format: '{point.percentage:.0f}%',
        },
      },
    },
    series: data,
  };

  const handleClickDownload = (type: 'CSV' | 'XLS') => {
    if (type === 'CSV') {
      chartRef.current.chart.downloadCSV();
    } else {
      chartRef.current.chart.downloadXLS();
    }
  };

  return (
    <Content className={`${styles['product-by-range-chart-box-container']} ${className}`}>
      <LoadingSpinerArea area="aderencia-ranges" size="md" style={{ position: 'absolute' }} />
      <div className={styles['header-container']}>
        <p className={styles.title}>Produtos por faixa</p>
        <OptionsDropdown id="detailing-more-options" data={OPTIONS_DROPDOWN} onClick={handleClickDownload} />
      </div>
      <div className={styles['period-break-container']}>
        <span className={styles['period-break-title']}>Quebra de período: </span>
        <Button appearance="subtle" className={styles['select-period-btn']}>
          Semanal
        </Button>
      </div>
      <div className={styles['chart-container']}>
        <HighchartsReact ref={chartRef} highcharts={Highcharts} options={graficoData} />
      </div>
    </Content>
  );
};
